/*
  Feedback de "Adicionado" no botão de quick-add do card de produto.
  Não altera product-form.js: escuta o evento `cartUpdate` que ele já publica
  (pubsub.js) e marca o botão do card cujo formulário enviou aquela variante.
*/
(() => {
  if (window.cardProductAddedInit || typeof subscribe !== 'function') return;
  window.cardProductAddedInit = true;

  const ADDED_DURATION = 2200;
  let lastSubmitButton = null;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('.product-card-wrapper')) return;
      lastSubmitButton = form.querySelector('.quick-add__submit');
    },
    true
  );

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form' || !lastSubmitButton) return;

    const button = lastSubmitButton;
    lastSubmitButton = null;
    const variantInput = button.form?.querySelector('input[name="id"]');
    if (!variantInput || String(variantInput.value) !== String(event.productVariantId)) return;

    button.classList.add('is-added');
    clearTimeout(button.addedTimeout);
    button.addedTimeout = setTimeout(() => button.classList.remove('is-added'), ADDED_DURATION);
  });
})();
